
import { defineComponent, SetupContext, PropType, computed } from "vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "SelectingIngredientListItem",
  props: {
    /**
     * id
     */
    id: {
      type: Number,
      required: true
    },
    /**
     * 画像
     */
    imageUrl: {
      type: String,
      required: true
    },
    /**
     * 食材名
     */
    ingredientName: {
      type: String,
      required: true
    },
    /**
     * 選択状態
     */
    isSelected: {
      type: Boolean,
      default: false
    },
    /**
     * ボタンラベル
     */
    isShowButton: {
      type: String,
      required: true
    },
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("SelectingIngredientListItem setup start");
    NativeClient.sendDebugLog("SelectingIngredientListItem setup name = " + props.ingredientName + " isShowButton = " + props.isShowButton + ", isSelect = " + props.isSelected);

    const selectClick = () => {
      context.emit("select-ingredient", props.id, !props.isSelected);
    };

    const clickButton = () => {
      context.emit("click-button", props.id);
    };

    const getMarginRight = () => {
      return props.isShowButton ? "7rem" : "0rem";
    };

    /**
     * 画像読み込みエラー発生
     */
    const onImageError = (event: Event) =>{
      NativeClient.sendDebugLog("SelectingIngredientListItem onImageError");
      if (event.target) {
        NativeClient.sendDebugLog("SelectingIngredientListItem onImageError target exist");
        (event.target as HTMLImageElement).src = require("@/assets/images/food_noimage.png"); 
      }
    };
    return {
      selectClick,
      clickButton,
      getMarginRight,
      onImageError
    };
  }
});
